The scheme ID of the event.

Currently, only the `seekAnz` and `seekAnzPublicTest` schemes emit `PositionProfileUpdated` events.
